import type { Locale } from './config';

export const canonicalToLocalized: Record<Locale, Record<string, string>> = {
  "en": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "es": {
    "gaming": "juegos",
    "retail-and-shopping": "comercio-y-compras",
    "streaming-and-subscriptions": "streaming-y-suscripciones",
    "food-and-restaurants": "comida-y-restaurantes",
    "fashion-and-apparel": "moda-y-ropa",
    "travel-hotels-and-mobility": "viajes-hoteles-y-movilidad",
    "entertainment-gifts-and-events": "entretenimiento-regalos-y-eventos",
    "home-and-lifestyle": "hogar-y-estilo-de-vida",
    "beauty-and-personal-care": "belleza-y-cuidado-personal",
    "books-education-and-elearning": "libros-educacion-y-elearning",
    "electronics-and-tech": "electronica-y-tecnologia",
    "groceries-and-supermarkets": "comestibles-y-supermercados",
    "sports-health-and-fitness": "deportes-salud-y-fitness",
    "other": "otros"
  },
  "fr": {
    "gaming": "jeux",
    "retail-and-shopping": "commerce-et-achats",
    "streaming-and-subscriptions": "streaming-et-abonnements",
    "food-and-restaurants": "nourriture-et-restaurants",
    "fashion-and-apparel": "mode-et-vetements",
    "travel-hotels-and-mobility": "voyages-hotels-et-mobilite",
    "entertainment-gifts-and-events": "divertissement-cadeaux-et-evenements",
    "home-and-lifestyle": "maison-et-style-de-vie",
    "beauty-and-personal-care": "beaute-et-soins-personnels",
    "books-education-and-elearning": "livres-education-et-elearning",
    "electronics-and-tech": "electronique-et-technologie",
    "groceries-and-supermarkets": "epicerie-et-supermarches",
    "sports-health-and-fitness": "sports-sante-et-fitness",
    "other": "autres"
  },
  "de": {
    "gaming": "gaming",
    "retail-and-shopping": "einzelhandel-und-shopping",
    "streaming-and-subscriptions": "streaming-und-abonnements",
    "food-and-restaurants": "essen-und-restaurants",
    "fashion-and-apparel": "mode-und-bekleidung",
    "travel-hotels-and-mobility": "reisen-hotels-und-mobilitaet",
    "entertainment-gifts-and-events": "unterhaltung-geschenke-und-events",
    "home-and-lifestyle": "haus-und-lifestyle",
    "beauty-and-personal-care": "schoenheit-und-koerperpflege",
    "books-education-and-elearning": "buecher-bildung-und-elearning",
    "electronics-and-tech": "elektronik-und-technik",
    "groceries-and-supermarkets": "lebensmittel-und-supermaerkte",
    "sports-health-and-fitness": "sport-gesundheit-und-fitness",
    "other": "sonstiges"
  },
  "ro": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-si-cumparaturi",
    "streaming-and-subscriptions": "streaming-si-abonamente",
    "food-and-restaurants": "mancare-si-restaurante",
    "fashion-and-apparel": "moda-si-imbracaminte",
    "travel-hotels-and-mobility": "calatorii-hoteluri-si-mobilitate",
    "entertainment-gifts-and-events": "divertisment-cadouri-si-evenimente",
    "home-and-lifestyle": "casa-si-lifestyle",
    "beauty-and-personal-care": "frumusete-si-ingrijire-personala",
    "books-education-and-elearning": "carti-educatie-si-elearning",
    "electronics-and-tech": "electronice-si-tech",
    "groceries-and-supermarkets": "alimente-si-supermarketuri",
    "sports-health-and-fitness": "sport-sanatate-si-fitness",
    "other": "altele"
  },
  "pt": {
    "gaming": "jogos",
    "retail-and-shopping": "varejo-e-compras",
    "streaming-and-subscriptions": "streaming-e-assinaturas",
    "food-and-restaurants": "comida-e-restaurantes",
    "fashion-and-apparel": "moda-e-vestuario",
    "travel-hotels-and-mobility": "viagens-hoteis-e-mobilidade",
    "entertainment-gifts-and-events": "entretenimento-presentes-e-eventos",
    "home-and-lifestyle": "casa-e-estilo-de-vida",
    "beauty-and-personal-care": "beleza-e-cuidados-pessoais",
    "books-education-and-elearning": "livros-educacao-e-elearning",
    "electronics-and-tech": "eletronicos-e-tecnologia",
    "groceries-and-supermarkets": "mercearia-e-supermercados",
    "sports-health-and-fitness": "esportes-saude-e-fitness",
    "other": "outros"
  },
  "ar": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "bn": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "hi": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "zh": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "it": {
    "gaming": "gaming",
    "retail-and-shopping": "vendita-e-shopping",
    "streaming-and-subscriptions": "streaming-e-abbonamenti",
    "food-and-restaurants": "cibo-e-ristoranti",
    "fashion-and-apparel": "moda-e-abbigliamento",
    "travel-hotels-and-mobility": "viaggi-hotel-e-mobilita",
    "entertainment-gifts-and-events": "intrattenimento-regali-e-eventi",
    "home-and-lifestyle": "casa-e-lifestyle",
    "beauty-and-personal-care": "bellezza-e-cura-personale",
    "books-education-and-elearning": "libri-educazione-e-elearning",
    "electronics-and-tech": "elettronica-e-tecnologia",
    "groceries-and-supermarkets": "alimentari-e-supermercati",
    "sports-health-and-fitness": "sport-salute-e-fitness",
    "other": "altro"
  },
  "ru": {
    "gaming": "gaming",
    "retail-and-shopping": "roznichnaya-torgovlya-i-shopping",
    "streaming-and-subscriptions": "striming-i-podpiski",
    "food-and-restaurants": "eda-i-restorany",
    "fashion-and-apparel": "moda-i-odezhda",
    "travel-hotels-and-mobility": "puteshestviya-oteli-i-mobilnost",
    "entertainment-gifts-and-events": "razvlecheniya-podarki-i-meropriyatiya",
    "home-and-lifestyle": "dom-i-lifestyle",
    "beauty-and-personal-care": "krasota-i-ukhod",
    "books-education-and-elearning": "knigi-obrazovanie-i-elearning",
    "electronics-and-tech": "elektronika-i-tekhnologii",
    "groceries-and-supermarkets": "produkty-i-supermarkety",
    "sports-health-and-fitness": "sport-zdorovye-i-fitnes",
    "other": "drugoe"
  }
} as Record<Locale, Record<string, string>>;

export const localizedToCanonical: Record<Locale, Record<string, string>> = {
  "en": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "es": {
    "juegos": "gaming",
    "comercio-y-compras": "retail-and-shopping",
    "streaming-y-suscripciones": "streaming-and-subscriptions",
    "comida-y-restaurantes": "food-and-restaurants",
    "moda-y-ropa": "fashion-and-apparel",
    "viajes-hoteles-y-movilidad": "travel-hotels-and-mobility",
    "entretenimiento-regalos-y-eventos": "entertainment-gifts-and-events",
    "hogar-y-estilo-de-vida": "home-and-lifestyle",
    "belleza-y-cuidado-personal": "beauty-and-personal-care",
    "libros-educacion-y-elearning": "books-education-and-elearning",
    "electronica-y-tecnologia": "electronics-and-tech",
    "comestibles-y-supermercados": "groceries-and-supermarkets",
    "deportes-salud-y-fitness": "sports-health-and-fitness",
    "otros": "other"
  },
  "fr": {
    "jeux": "gaming",
    "commerce-et-achats": "retail-and-shopping",
    "streaming-et-abonnements": "streaming-and-subscriptions",
    "nourriture-et-restaurants": "food-and-restaurants",
    "mode-et-vetements": "fashion-and-apparel",
    "voyages-hotels-et-mobilite": "travel-hotels-and-mobility",
    "divertissement-cadeaux-et-evenements": "entertainment-gifts-and-events",
    "maison-et-style-de-vie": "home-and-lifestyle",
    "beaute-et-soins-personnels": "beauty-and-personal-care",
    "livres-education-et-elearning": "books-education-and-elearning",
    "electronique-et-technologie": "electronics-and-tech",
    "epicerie-et-supermarches": "groceries-and-supermarkets",
    "sports-sante-et-fitness": "sports-health-and-fitness",
    "autres": "other"
  },
  "de": {
    "gaming": "gaming",
    "einzelhandel-und-shopping": "retail-and-shopping",
    "streaming-und-abonnements": "streaming-and-subscriptions",
    "essen-und-restaurants": "food-and-restaurants",
    "mode-und-bekleidung": "fashion-and-apparel",
    "reisen-hotels-und-mobilitaet": "travel-hotels-and-mobility",
    "unterhaltung-geschenke-und-events": "entertainment-gifts-and-events",
    "haus-und-lifestyle": "home-and-lifestyle",
    "schoenheit-und-koerperpflege": "beauty-and-personal-care",
    "buecher-bildung-und-elearning": "books-education-and-elearning",
    "elektronik-und-technik": "electronics-and-tech",
    "lebensmittel-und-supermaerkte": "groceries-and-supermarkets",
    "sport-gesundheit-und-fitness": "sports-health-and-fitness",
    "sonstiges": "other"
  },
  "ro": {
    "gaming": "gaming",
    "retail-si-cumparaturi": "retail-and-shopping",
    "streaming-si-abonamente": "streaming-and-subscriptions",
    "mancare-si-restaurante": "food-and-restaurants",
    "moda-si-imbracaminte": "fashion-and-apparel",
    "calatorii-hoteluri-si-mobilitate": "travel-hotels-and-mobility",
    "divertisment-cadouri-si-evenimente": "entertainment-gifts-and-events",
    "casa-si-lifestyle": "home-and-lifestyle",
    "frumusete-si-ingrijire-personala": "beauty-and-personal-care",
    "carti-educatie-si-elearning": "books-education-and-elearning",
    "electronice-si-tech": "electronics-and-tech",
    "alimente-si-supermarketuri": "groceries-and-supermarkets",
    "sport-sanatate-si-fitness": "sports-health-and-fitness",
    "altele": "other"
  },
  "pt": {
    "jogos": "gaming",
    "varejo-e-compras": "retail-and-shopping",
    "streaming-e-assinaturas": "streaming-and-subscriptions",
    "comida-e-restaurantes": "food-and-restaurants",
    "moda-e-vestuario": "fashion-and-apparel",
    "viagens-hoteis-e-mobilidade": "travel-hotels-and-mobility",
    "entretenimento-presentes-e-eventos": "entertainment-gifts-and-events",
    "casa-e-estilo-de-vida": "home-and-lifestyle",
    "beleza-e-cuidados-pessoais": "beauty-and-personal-care",
    "livros-educacao-e-elearning": "books-education-and-elearning",
    "eletronicos-e-tecnologia": "electronics-and-tech",
    "mercearia-e-supermercados": "groceries-and-supermarkets",
    "esportes-saude-e-fitness": "sports-health-and-fitness",
    "outros": "other"
  },
  "ar": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "bn": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "hi": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "zh": {
    "gaming": "gaming",
    "retail-and-shopping": "retail-and-shopping",
    "streaming-and-subscriptions": "streaming-and-subscriptions",
    "food-and-restaurants": "food-and-restaurants",
    "fashion-and-apparel": "fashion-and-apparel",
    "travel-hotels-and-mobility": "travel-hotels-and-mobility",
    "entertainment-gifts-and-events": "entertainment-gifts-and-events",
    "home-and-lifestyle": "home-and-lifestyle",
    "beauty-and-personal-care": "beauty-and-personal-care",
    "books-education-and-elearning": "books-education-and-elearning",
    "electronics-and-tech": "electronics-and-tech",
    "groceries-and-supermarkets": "groceries-and-supermarkets",
    "sports-health-and-fitness": "sports-health-and-fitness",
    "other": "other"
  },
  "it": {
    "gaming": "gaming",
    "vendita-e-shopping": "retail-and-shopping",
    "streaming-e-abbonamenti": "streaming-and-subscriptions",
    "cibo-e-ristoranti": "food-and-restaurants",
    "moda-e-abbigliamento": "fashion-and-apparel",
    "viaggi-hotel-e-mobilita": "travel-hotels-and-mobility",
    "intrattenimento-regali-e-eventi": "entertainment-gifts-and-events",
    "casa-e-lifestyle": "home-and-lifestyle",
    "bellezza-e-cura-personale": "beauty-and-personal-care",
    "libri-educazione-e-elearning": "books-education-and-elearning",
    "elettronica-e-tecnologia": "electronics-and-tech",
    "alimentari-e-supermercati": "groceries-and-supermarkets",
    "sport-salute-e-fitness": "sports-health-and-fitness",
    "altro": "other"
  },
  "ru": {
    "gaming": "gaming",
    "roznichnaya-torgovlya-i-shopping": "retail-and-shopping",
    "striming-i-podpiski": "streaming-and-subscriptions",
    "eda-i-restorany": "food-and-restaurants",
    "moda-i-odezhda": "fashion-and-apparel",
    "puteshestviya-oteli-i-mobilnost": "travel-hotels-and-mobility",
    "razvlecheniya-podarki-i-meropriyatiya": "entertainment-gifts-and-events",
    "dom-i-lifestyle": "home-and-lifestyle",
    "krasota-i-ukhod": "beauty-and-personal-care",
    "knigi-obrazovanie-i-elearning": "books-education-and-elearning",
    "elektronika-i-tekhnologii": "electronics-and-tech",
    "produkty-i-supermarkety": "groceries-and-supermarkets",
    "sport-zdorovye-i-fitnes": "sports-health-and-fitness",
    "drugoe": "other"
  }
} as Record<Locale, Record<string, string>>;
